import React from "react";
import Modal from "../Modal";

export default function ConfirmModal({ confirmContext = "success", confirmText, message, onConfirm, onHidden, testId, title }) {
  const modalRef = React.useRef(null);
  const close = () => modalRef.current.hide();
  const confirm = () => {
    close();
    onConfirm();
  };

  return (
    <Modal
      footer={(
        <>
          <button className="btn btn-default" data-testid={`${testId}-cancel`} onClick={close}>Cancel</button>
          <button className={`btn btn-${confirmContext}`} data-testid={`${testId}-confirm`} onClick={confirm}>{confirmText}</button>
        </>
      )}
      onHidden={onHidden}
      ref={modalRef}
      size="small"
      title={title}
    >
      <p data-testid={testId} style={{ marginBottom: 0 }}>{message}</p>
    </Modal>
  );
}
